export const PRODUCTION = 'production'
export const STAGING = 'staging'
export const EXTERNAL_DEMO = 'external-demo'
export const DEVELOPMENT = 'development'
export const ON_PREM = 'on-prem'
